<script>
  import { createEventDispatcher } from 'svelte';
  import Button from '@components/Button.svelte';

  const dispatch = createEventDispatcher();
  export let mobile = false;
  export let selectedQuestions = [];
  let maxSelectedQuestions = 3;

  $: selectedQuestionsRemaining = maxSelectedQuestions - selectedQuestions.length;
</script>

<style style="text/scss" lang="scss">
  .creator-spotlight-questions {
    .ui-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 12px;
      gap: 16px;
    }
    .ui-title {
      font-weight: 500;
      font-size: 18px;
      line-height: 22px;
      max-width: 350px;
    }
    .ui-subtitle {
      color: #717171;
      margin-bottom: 16px;
    }
    .ui-back,
    .ui-close {
      background-color: transparent;
      border: none;
      margin: 0;
      padding: 0;
      opacity: 0.5;

      &:hover {
        opacity: 1;
      }
    }

    .question-container {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 12px 20px;
      border: 1px dashed var(--neutral-input-gray, #c6c6c6);
      text-align: left;
      border-radius: 12px;
      cursor: pointer;

      &:hover {
        background: #f1f1f1;
      }

      &.selected {
        border-style: solid;
      }

      .icon__add {
        background: #896bd9;
        width: 20px;
        height: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 999px;
      }

      .icon__edit {
        cursor: pointer;
        width: 20px;
      }
    }

    .question-item {
      font-size: 16px;
      margin-bottom: 4px;
    }

    .answer-item {
      font-size: 14px;
      margin-bottom: 0;
      word-break: break-word;
    }

    .selected-questions-container {
      display: flex;
      flex-direction: column;
      gap: 16px;
      margin-bottom: 24px;
    }
  }
</style>

<div class="creator-spotlight-questions" class:mobile={mobile}>
  <div class="ui-header">
    <button
      class="ui-back"
      on:click={() => {
        dispatch('back');
      }}>
      <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M4.85501 7.26609L10.5901 1.49831L11.6538 2.55596L5.91867 8.32373C5.82171 8.42125 5.82171 8.57877 5.91867 8.67628L11.6538 14.4441L10.5901 15.5017L4.85501 9.73393C4.17626 9.05132 4.17626 7.94869 4.85501 7.26609Z"
          fill="#1C1C1C" />
      </svg>
    </button>
    <div class="ui-title">Questions</div>
    <button
      class="ui-close"
      on:click={() => {
        dispatch('close');
      }}
      ><svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M6.93932 8.50003L2.00049 13.4386L3.06112 14.4993L8 9.56066L12.9389 14.4993L13.9995 13.4386L9.06069 8.50003L13.9995 3.56142L12.9389 2.50073L8 7.43939L3.06112 2.50073L2.00049 3.56142L6.93932 8.50003Z"
          fill="#1C1C1C" />
      </svg>
    </button>
  </div>
  <p class="ui-subtitle">Answer 3 questions</p>

  <div class="selected-questions-container">
    {#each selectedQuestions as question}
      <div
        class="question-container selected"
        on:click={() => dispatch('edit', { id: question.id, value: question.value, answer: question.answer })}>
        <div>
          <div class="question-item ui-title">{question.value}</div>
          <div class="answer-item ui-subtitle">{question.answer}</div>
        </div>
        <div class="icon__edit">
          <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M11.1445 9.73391L5.40937 15.5017L4.3457 14.444L10.0808 8.67626C10.1778 8.57875 10.1778 8.42123 10.0808 8.32372L4.3457 2.55594L5.40937 1.49829L11.1445 7.26607C11.8232 7.94868 11.8232 9.0513 11.1445 9.73391Z"
              fill="#717171" />
          </svg>
        </div>
      </div>
    {/each}
    {#each Array(selectedQuestionsRemaining) as _}
      <div
        class="question-container"
        on:click={() => {
          dispatch('goToQuestion');
        }}>
        <div>
          <div class="question-item ui-title">Select a question</div>
          <div class="answer-item ui-subtitle">And write your own answer</div>
        </div>
        <div class="icon__add">
          <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M5.46429 6.99142V11.5H6.53571V6.99142H11V5.91999H6.53571V1.5H5.46429V5.91999H1V6.99142H5.46429Z"
              fill="white" />
          </svg>
        </div>
      </div>
    {/each}
  </div>
  <div class="finished-btn">
    <Button
      disabled={selectedQuestions.length < 3}
      colorScheme="black"
      style="padding-left: 40px; padding-right: 40px; width: auto; margin: 0;"
      text={selectedQuestions.length < 3 ? 'Answer 3 questions' : 'Continue'}
      on:click={() => {
        dispatch('finished');
      }} />
  </div>
</div>
